import type { ActivityActorType } from 'definitions';

type ActivityActorMarkerParams = { actorType: ActivityActorType; userId: number | null };

/**
 * Says who acted when it was not the person in the row: an agent with their personal access token
 * (the MCP connector or any other client), or Pertento itself (the scheduler and the pipeline
 * engine). Null for a person, who needs no marker.
 *
 * A `user` line with no user is automatic too: before PER-327 every line was stored as `user`,
 * and the only writers that left `user_id` empty were the engines. Those rows were not
 * backfilled, so this is how they read correctly.
 */
export function activityActorMarker({ actorType, userId }: ActivityActorMarkerParams): string | null {
  if (actorType === 'agent') return 'via agent';
  if (actorType === 'system' || userId === null) return 'automatic';
  return null;
}
